<template>
  <div class="c-car-price">
    <img class="c-car-price__image" src="/img/bofi-car.png" />
    <div class="c-car-price__label-container">
      <div class="c-car-price__label">Verkoopprijs</div>
      <div class="c-car-price__price">€ {{ formattedPrice }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CarPrice",
  props: {
    price: Number,
  },
  computed: {
    formattedPrice: function() {
      return this.price;
    },
  },
};
</script>
